import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from "yup";
import axios from 'axios';
import { Field, Form, Formik } from 'formik';
// import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';

import { LoginImage, Logo, MailIcon, GoogleIcon, Users1 } from '../../common/imagePath';

import { clientId } from '../../common/common';
import config from "../../config/config";
import { toastError, toastSuccess } from '../../common/Toast';

const Register = () => {
    const [eye, seteye] = useState(true);

    const onEyeClick = () => {
        seteye(!eye)
    }

    let navigate = useNavigate();

    const schema = Yup.object().shape({
        name: Yup.string()
            .required("Name is required"),
        email: Yup.string()
            .required("Email is required")
            .email('Email is invalid'),
        password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters")
            .max(20, 'Password must not exceed 20 characters'),
    });

    const handleSubmit = async (e) => {


        axios.post(`${config.authenticationBaseUrl}/users/registration`, {
            name: e.name,
            emailid: e.email,
            password: e.password,
            googleid: e.googleId
        }, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        })
            .then((res) => {


                if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess('Register Successfully');

                    navigate('/login');
                }
                // else if (res.data.ResponseCode === "ERROR" && res.data.ResponseID === -1) {
                //     toastError("Invalid username or password");
                // }
                else {
                    toastError("Somthing went wrong!");
                }
            })
            .catch((error) => {

            });
    };

    useEffect(() => {
        const initClient = () => {
            gapi.client.init({
                clientId: clientId,
                scope: ''
            });
        };
        gapi.load('client:auth2', initClient);
    });

    const onSuccess = (res) => {

        handleSubmit(res.profileObj);
    };

    const onFailure = (err) => {

    };

    return (
        <Fragment>

            {/* <div className="login-page">
                <div className="login-box">
                    <div className="card card-outline card-primary">
                        <div className="card-header text-center">
                            <span className="brand-text font-weight-light h1" >Register</span>
                        </div>
                        <div className="card-body">
                            <p className="login-box-msg">Sign in to start your session</p>
                            <hr />
                            <GoogleLogin
                                clientId={clientId}
                                buttonText="Sign in with Google"
                                onSuccess={onSuccess}
                                onFailure={onFailure}
                                cookiePolicy={'single_host_origin'}
                                isSignedIn={true}
                            />
                            <hr />
                            <Formik
                                initialValues={{ name: "", email: "", password: "" }}
                                validationSchema={schema}
                                onSubmit={handleSubmit}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                }) => (
                                    <Form>
                                        <div className="mb-3">
                                            <div className="input-group">
                                                <Field type="name" name="name" className="form-control" placeholder="Name" onBlur={handleBlur} onChange={handleChange} />
                                            </div>
                                            <div>
                                                <span className="text-danger">
                                                    {touched.name && errors.name ? errors.name : ''}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <div className="input-group">
                                                <Field type="email" name="email" className="form-control" placeholder="Email" onBlur={handleBlur} onChange={handleChange} />
                                            </div>
                                            <div>
                                                <span className="text-danger">
                                                    {touched.email && errors.email ? errors.email : ''}
                                                </span>
                                            </div>
                                        </div>
                                        <div className=" mb-3">
                                            <div className="input-group">
                                                <Field type="password" name="password" className="form-control" placeholder="Password" value={values.password} onBlur={handleBlur} onChange={handleChange} />
                                            </div>
                                            <span className="text-danger">
                                                {touched.password && errors.password ? errors.password : ''}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <button type="submit" className="btn btn-dark btn-block">Sign Up</button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="main-wrapper">
                <Helmet>
                    <title>SignIn - Sonar POS</title>
                    <meta name="description" content="SignIn page" />
                </Helmet>
                <div className="account-content">
                    <div className="login-wrapper">
                        <div className="login-content">
                            <div className="login-userset">
                                <Formik
                                    initialValues={{ email: "", password: "" }}
                                    validationSchema={schema}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                    }) => (
                                        <Form>
                                            <div className="login-logo">
                                                <img src={Logo} alt="img" />
                                            </div>
                                            <div className="login-userheading">
                                                <h5>Create an Account</h5>
                                                <h6>Continue where you left off</h6>
                                            </div>
                                            <div className="form-login">
                                                <label>Full Name</label>
                                                <div className="form-addons">
                                                    <Field
                                                        type="text"
                                                        name="name"
                                                        className={` ${errors.name ? "is-invalid form-control" : "form-control"}`}
                                                        placeholder="Enter your full name"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <img src={Users1} alt="img" />
                                                    <div className="invalid-feedback">{touched.name && errors.name ? errors.name : ''}</div>
                                                </div>
                                            </div>
                                            <div className="form-login">
                                                <label>Email</label>
                                                <div className="form-addons">
                                                    <Field
                                                        type="text"
                                                        name="email"
                                                        className={` ${errors.email ? 'is-invalid form-control' : 'form-control'}`}
                                                        placeholder="Enter your email address"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <img src={MailIcon} alt="img" />
                                                    <div className="invalid-feedback">{touched.email && errors.email ? errors.email : ''}</div>
                                                </div>
                                            </div>
                                            <div className="form-login">
                                                <label>Password</label>
                                                <div className="pass-group">
                                                    <Field
                                                        type={eye ? "password" : "text"}
                                                        name="password"
                                                        className={` ${errors.password ? 'is-invalid form-control' : 'form-control'}`}
                                                        placeholder="Enter your password"
                                                        value={values.password}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    <span onClick={onEyeClick} className={`fas toggle-password ${eye ? "fa-eye-slash" : "fa-eye"} `} />
                                                    <div className="invalid-feedback">{touched.password && errors.password ? errors.password : ''}</div>

                                                </div>

                                            </div>
                                            <div className="form-login">
                                                <button type="submit" className="btn btn-sm btn-primary w-100">
                                                    Sign Up
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                                <div className="signinform text-center">
                                    <h4>
                                        Already a user?{" "}
                                        <Link to="/login" className="hover-a">
                                            Sign In
                                        </Link>
                                    </h4>
                                </div>
                                <div className="form-setlogin">
                                    <h4 className="signup-text">Or sign up with</h4>
                                </div>
                                <div className="form-sociallink">
                                    <ul>
                                        <li>
                                            {/* <GoogleLogin
                                                clientId={clientId}
                                                buttonText="Sign in with Google"
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                cookiePolicy={'single_host_origin'}
                                                isSignedIn={true}
                                                render={renderProps => (
                                                    <Link onClick={renderProps.onClick}>
                                                        <img
                                                            src={GoogleIcon}
                                                            className="me-2"
                                                            alt="google"
                                                        />
                                                        Sign Up using Google
                                                    </Link>
                                                )} */}
                                            {/* /> */}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="login-img">
                            <img src={LoginImage} alt="img" />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Register;